import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ILink } from '../../links/link.interface';
import { NavigationService } from '../../../../services/navigation.service';
import { Subscription } from 'rxjs';
import { FormService } from 'app/services/form.service';
import { Router } from '@angular/router';
import { UnlockCaseModel } from 'app/models/unlock-case.model';
import { AdminService } from 'app/services/admin.service';
import { UserService } from 'app/users/user.service';

@Component({
  selector: 'app-navigation-desktop-link',
  templateUrl: 'link.component.html'
})
export class LinkComponent implements OnInit, OnDestroy {
  @Input() navigationLink!: ILink;
  @Input() unlockCase!: boolean;
  @Input() externalLink!: boolean;
  @Input() forceReload!: boolean;
  @Input() opened!: boolean;
  
  link!: ILink;
  shouldUnlockCase!: boolean;
  isExternal!: boolean;
  isNamedRoute!: boolean;
  isSimpleLocal!: boolean;
  isOpened!: boolean;
  private openedSubscription: Subscription;

  constructor(
    protected navigationService: NavigationService, 
    protected formService: FormService, 
    private adminService: AdminService,  
    private userService: UserService,
    private router: Router) {
    this.openedSubscription = this.navigationService.getSideNavOpenedUpdate().subscribe(
      opened => {
        this.isOpened = opened.value;
      });
  }

  ngOnInit(): void {
    this.link = this.navigationLink;
    this.shouldUnlockCase = this.unlockCase;
    this.isExternal = this.externalLink && !this.forceReload;
    this.isSimpleLocal = !this.externalLink && !this.forceReload;
    this.isNamedRoute = !this.externalLink && this.forceReload;
    this.isOpened = this.opened;
  }

  ngOnDestroy(): void {
      this.openedSubscription.unsubscribe();
  }

  clickAction() {
    if(this.shouldUnlockCase) {
      var unlockModel;
  
      if(this.formService.getCurrentUsanFormValue()?.get('caseSysId')?.value) {
        unlockModel = UnlockCaseModel.parseFormGroup(this.formService.getCurrentUsanFormValue());
      } else if(this.adminService.getCurrentApplicationCaseSysId()) {
        unlockModel = UnlockCaseModel.parseValues(
          { 
            caseSysId: this.adminService.getCurrentApplicationCaseSysId(),
            lockedById: this.userService.profile.uniqueId ?? ''
          }
        );
      }

      this.formService.unlockCase(unlockModel).subscribe();
    }

    if(this.isExternal) {
      window.open(this.link.externalUrl, "_blank");
    } else {
      this.router.navigate([this.route]);
    }
  }

  get route() {
    return this.link.route;
  }

  get text() {
    return this.link.text;
  }

  get iconName() {
    return this.link.iconName;
  }

  get tooltipText() {
    if(this.isOpened)
      return '';
    return this.link.tooltipText;
  }

  get selectedClass() {
    if(this.isOpened)
      return 'accordion__list-item--selected';

      return 'accordion__list-item--selected-collapsed';
  }
}
